
/**
 * Builds a full REST API URL for the given PCU and API path.
 * @param {"pcu-a"|"pcu-b"} pcu
 * @param {string} path
 */
export function adptRestEndpoint(address, path) {
  return address?.startsWith("/")
    ? `${window.location.origin}${address}/api/v1/${path}`
    : address ? `http://${address}/api/v1/${path}` : undefined;
}

/**
 * A HTTP response parser for the custom hook useRestPolling, for the active DECs endpoint of ats-adpt-rest.
 * It is a bit inconsistent, and needs different parsing on successful requests and failed ones.
 * We also use the opportunity to remap the objects to a simple array of event codes.
 *
 * @param {Promise} response
 *   The raw HTTP response from the fetch call.
 *
 * @returns {number[]}
 *   A list of all diagnostic event codes in a successful the response.
 */
export async function activeDECsResponseParser(response) {
  if (response.ok) {
    const data = await response.text();
    return data ? JSON.parse(data) : [];
  } else {
    const data = await response.json();
    throw new Error(data.detail ? `Failed to poll active diagnostics. ${data.detail}`
                                : `HTTP error! status: ${response.status} (${response.statusText})`);
  }
};

